/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import PrimaryInput from "../../common/form/PrimaryInput";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import SelectSecondaryComponent from "../../common/form/SelectSecondaryComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import { Info, Warn } from "../../common/svg/AllSvg";
import PrimaryTextarea from "../../common/form/PrimaryTextarea";
import { useTranslation } from "react-i18next";

const Experiences = ({ DropdownIndicator, works, formik, setCreateExp, editExp, setEditExp, typeList, workingIdx, expDate, setExpDate, createExp, exeType, employement }: any) => {
    const { t } = useTranslation('common');
    const [present, setPresent] = useState<string>("no")
    const [dateErr, setDateErr] = useState<boolean>(false)
    const [dateFromErr, setDateFromErr] = useState<boolean>(false)
    const [dateToErr, setDateToErr] = useState<boolean>(false)
    const [gradeErr, setGradeErr] = useState<boolean>(false);
    const [basicPayErr, setBasicPayErr] = useState<boolean>(false);
    const [ctcErr, setCtcErr] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [scaleFcs, setScaleFcs] = useState<boolean>(false);
    const ref: any = useRef();

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);

    useEffect(() => {
        setPresent(formik?.values?.experiences?.[editExp]?.currently_working ?
            "yes" : "no"
        )
    }, [formik?.values?.experiences?.[editExp]?.currently_working])

    const expFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            company_name: ((!!editExp || editExp === 0) && formik?.values?.experiences?.[editExp]?.company_name) ? formik?.values?.experiences?.[editExp]?.company_name : '',
            job_title: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.job_title) ? formik?.values?.experiences?.[editExp]?.job_title : '',
            currently_working: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.currently_working) ? formik?.values?.experiences?.[editExp]?.currently_working : false,
            start_date: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.start_date) ? formik?.values?.experiences?.[editExp]?.start_date : '',
            end_date: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.end_date) ? formik?.values?.experiences?.[editExp]?.end_date : '',
            location: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.location) ? formik?.values?.experiences?.[editExp]?.location : '',
            pay_scale: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.pay_scale) ? formik?.values?.experiences?.[editExp]?.pay_scale : '',
            gap_reason: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.gap_reason) ? formik?.values?.experiences?.[editExp]?.gap_reason : '',
            employment: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.employment) ? employement?.find((item: any) => item?.value === formik?.values?.experiences?.[editExp]?.employment) : '',
            experience_type: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.experience_type) ? exeType?.find((item: any) => item?.value === formik?.values?.experiences?.[editExp]?.experience_type) : '',
            pay_scale_gov: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.pay_scale_gov) ? formik?.values?.experiences?.[editExp]?.pay_scale_gov : '',
            basic_pay: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.basic_pay) ? formik?.values?.experiences?.[editExp]?.basic_pay : '',
            nature_of_work: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.nature_of_work) ? formik?.values?.experiences?.[editExp]?.nature_of_work : '',
            employment_type_id: ((!!editExp || editExp === 0) && !!formik?.values?.experiences?.[editExp]?.employment_type_id) ? { label: formik?.values?.experiences?.[editExp]?.employment_type_name, value: formik?.values?.experiences?.[editExp]?.employment_type_id } : '',
        },
        validationSchema: yup.object().shape({
            company_name: yup.string().required(t("recruitment.profile.err.company_name")),
            job_title: yup.string().required(t("recruitment.profile.err.job_title")),
            currently_working: yup.boolean(),
            start_date: yup.date().required(t("recruitment.profile.err.from")),
            end_date: yup.date(),
            location: yup.string().matches(/^[A-Za-z\s]+$/, t("contact_us.form.alpha_char_err")).required(t("recruitment.profile.err.location")),
            gap_reason: yup.string().max(512, t("recruitment.profile.err.gap_reason_len")),
            nature_of_work: yup.string().max(512, t("recruitment.profile.err.nature_of_work_len")).required(t("recruitment.profile.err.nature_of_work")),
            employment: yup.object().required(t("recruitment.profile.err.employment")),
            employment_type_id: yup.object().required(t("recruitment.profile.err.employment_type_id")),
            experience_type: yup.object().required(t("recruitment.profile.err.experience_type")),
            pay_scale_gov: yup.string()
        }),
        onSubmit: async (values: any, { resetForm }: any) => {
            //submit
            if (present !== "yes" && !!!values?.end_date) {
                setDateErr(true)
                return;
            }
            if (values?.employment?.value === "private" && !!!values?.pay_scale) {
                setCtcErr(true)
                return
            }

            if (values?.employment?.value !== "private" && !!!values?.pay_scale_gov) {
                setGradeErr(true)
                return
            }

            if (values?.employment?.value !== "private" && !!!values?.basic_pay) {
                setBasicPayErr(true)
                return
            }

            if (values?.currently_working) {
                if (!!editExp || editExp === 0) {
                    let arr: any[] = [...expDate]
                    arr[editExp] = { min: values?.start_date, max: new Date().toISOString().split("T")[0] }
                    setExpDate(arr)
                } else {
                    setExpDate([...expDate, { min: values?.start_date, max: new Date().toISOString().split("T")[0] }])
                }
            }
            else {
                if (!!editExp || editExp === 0) {
                    let arr: any[] = [...expDate]
                    arr[editExp] = { min: values?.start_date, max: values?.end_date }
                    setExpDate(arr)
                } else {
                    setExpDate([...expDate, { min: values?.start_date, max: values?.end_date }])
                }
            }

            if (!!editExp || editExp === 0) {
                let arr: any[] = [...formik?.values?.experiences]
                arr[editExp] = {
                    ...values,
                    experience_type: values?.experience_type?.value,
                    experience_type_name: values?.experience_type?.label,
                    employment_name: values?.employment?.label,
                    employment: values?.employment?.value,
                    employment_type_name: values?.employment_type_id?.label,
                    employment_type_id: values?.employment_type_id?.value,
                }
                formik.setFieldValue("experiences", arr)
            } else {
                let obj: any = {
                    ...values,
                    experience_type: values?.experience_type?.value,
                    experience_type_name: values?.experience_type?.label,
                    employment_name: values?.employment?.label,
                    employment: values?.employment?.value,
                    employment_type_name: values?.employment_type_id?.label,
                    employment_type_id: values?.employment_type_id?.value,
                }
                formik.setFieldValue("experiences", [...formik?.values?.experiences, obj])
            }
            setCreateExp(false)
            setEditExp(null)
            resetForm({ values: '' });
        }
    });

    const handleStartDate = (e: any) => {
        if (expDate?.length > 0) {
            if ((!!editExp || editExp === 0)) {
                let arr: any[] = expDate?.filter((i: any, idx: number) => idx !== editExp)
                if (arr?.length > 0) {
                    const isDisabled = arr.some((range: any) =>
                        e.target.value >= range.min && e.target.value <= range.max
                    );

                    if (isDisabled) {
                        expFormik.setFieldValue("start_date", '')
                        setDateFromErr(true)
                    } else {
                        setDateFromErr(false)
                        expFormik.setFieldValue("start_date", e.target.value)
                    }
                } else {
                    setDateFromErr(false)
                    expFormik.setFieldValue("start_date", e.target.value)
                }
            } else {
                const isDisabled = expDate.some((range: any) =>
                    e.target.value >= range.min && e.target.value <= range.max
                );

                if (isDisabled) {
                    expFormik.setFieldValue("start_date", '')
                    setDateFromErr(true)
                } else {
                    setDateFromErr(false)
                    expFormik.setFieldValue("start_date", e.target.value)
                }
            }
        } else {
            setDateFromErr(false)
            expFormik.setFieldValue("start_date", e.target.value)
        }

    }

    const handleEndDate = (e: any) => {
        if (expDate?.length > 0) {
            if ((!!editExp || editExp === 0)) {
                let arr: any[] = expDate?.filter((i: any, idx: number) => idx !== editExp)
                if (arr?.length > 0) {
                    const isDisabled = arr.some((range: any) =>
                        e.target.value >= range.min && e.target.value <= range.max
                    );

                    if (isDisabled) {
                        expFormik.setFieldValue("end_date", '')
                        setDateToErr(true)
                    } else {
                        setDateToErr(false)
                        !!e.target.value ? setDateErr(false) : setDateErr(true)
                        expFormik.setFieldValue("end_date", e.target.value)
                    }
                } else {
                    setDateToErr(false)
                    !!e.target.value ? setDateErr(false) : setDateErr(true)
                    expFormik.setFieldValue("end_date", e.target.value)
                }
            } else {
                const isDisabled = expDate.some((range: any) =>
                    e.target.value >= range.min && e.target.value <= range.max
                );

                if (isDisabled) {
                    expFormik.setFieldValue("end_date", '')
                    setDateToErr(true)
                } else {
                    setDateToErr(false)
                    !!e.target.value ? setDateErr(false) : setDateErr(true)
                    expFormik.setFieldValue("end_date", e.target.value)
                }
            }
        } else {
            setDateToErr(false)
            !!e.target.value ? setDateErr(false) : setDateErr(true)
            expFormik.setFieldValue("end_date", e.target.value)
        }
    }

    const handleKeyDown = (e: any) => {
        const key = e.key;
        const isNumber = /^[0-9]$/.test(key);
        const isHyphen = key === "-";

        if (!isNumber && !isHyphen && e.key !== "Backspace") {
            e.preventDefault();
        }
    };

    return (
        <div className="border border-[#E5E5E5] bg-[#FCFCFC] dark:bg-[#2e3037] dark:border-[#454545] py-[15px] px-[20px] xlx:py-[22px] xlx:px-[27px] flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[25px]">
            <div className="flex flex-col gap-[4px]">
                <PrimaryInput title={`${t("recruitment.profile.field.company_name")}*`} placeholder={t("recruitment.profile.placehoder.company_name")} type="text" name="company_name" value={expFormik?.values?.company_name} onBlur={expFormik?.handleBlur} onChange={expFormik?.handleChange} />
                {expFormik?.touched?.company_name && expFormik?.errors?.company_name && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.company_name}</span>
                </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
                <PrimaryInput title={`${t("recruitment.profile.field.job_title")}*`} placeholder={t("recruitment.profile.placehoder.job_title")} type="text" name="job_title" value={expFormik?.values?.job_title} onBlur={expFormik?.handleBlur} onChange={expFormik?.handleChange} />
                {expFormik?.touched?.job_title && expFormik?.errors?.job_title && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.job_title}</span>
                </div>}
            </div>

            <div className={`flex flex-col gap-[4px] ${!!workingIdx && (((!!editExp || editExp === 0) && ((editExp + 1) === workingIdx)) ? "" : "opacity-[0.5]")}`}>
                <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("recruitment.profile.field.cur_work")}</h6>
                <div className="flex items-center gap-[10px]">
                    {Array.isArray(works) && works?.map((item: any, index: number) => (
                        <button key={index} disabled={!!workingIdx ? (((!!editExp || editExp === 0) && ((editExp + 1) === workingIdx)) ? false : true) : false} className={`${present === item?.value ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e]"} disabled:!shadow-none hover:disabled:!shadow-none rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:cursor-not-allowed`} onClick={() => { setPresent(item?.value); item?.value === "yes" ? expFormik.setFieldValue("currently_working", true) : expFormik.setFieldValue("currently_working", false); item?.value === "yes" && expFormik.setFieldValue("end_date", ''); }}>{item?.label}</button>
                    ))}
                </div>
            </div>

            <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.from")}*`} name="start_date" type="date" placeholder={t("recruitment.profile.field.from")} value={expFormik?.values?.start_date} onBlur={expFormik?.handleBlur} onChange={(e: any) => handleStartDate(e)} max={!!expFormik?.values?.end_date ? new Date(expFormik?.values?.end_date).toISOString().split("T")[0] : new Date().toISOString().split("T")[0]} />
                    {(expFormik?.touched?.start_date && expFormik?.errors?.start_date && !dateFromErr) && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.start_date}</span>
                    </div>}

                    {dateFromErr && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.valid_date")}</span>
                    </div>}
                </div>

                {present === "yes" ?
                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.to")}*`}</h6>
                        <div className="rounded-[6px] bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug flex items-center dark:bg-bgDark dark:border-[#454545] dark:text-textBlackDull">
                            {t("recruitment.hr.candidate_detail.present")}
                        </div>
                    </div>
                    : <div className="flex flex-col gap-[4px]">
                        <PrimaryInput title={`${t("recruitment.profile.field.to")}*`} name="end_date" type="date" placeholder={t("recruitment.profile.field.to")} value={expFormik?.values?.end_date} onBlur={expFormik?.handleBlur} onChange={(e: any) => handleEndDate(e)} max={new Date().toISOString().split("T")[0]} min={!!expFormik?.values?.start_date && new Date(expFormik?.values?.start_date).toISOString().split("T")[0]} />
                        {(dateErr && !dateToErr) && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.to")}</span>
                        </div>}

                        {dateToErr && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.valid_date")}</span>
                        </div>}
                    </div>}

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.home.job_list.emp")}*`}</h6>
                    <SelectSecondaryComponent
                        options={typeList}
                        name="employment_type_id"
                        placeholder={t("recruitment.profile.placehoder.employment_type_id")}
                        isSearchable={false}
                        arrow={true}
                        components={{ DropdownIndicator }}
                        onChange={(e: any) => expFormik.setFieldValue("employment_type_id", e)}
                        onBlur={(e: any) => expFormik.setFieldTouched("employment_type_id", e)}
                        value={!!expFormik.values.employment_type_id ? typeList?.find((item: any) => item?.value === expFormik.values.employment_type_id?.value) : expFormik.values.employment_type_id}
                    />

                    {expFormik?.touched?.employment_type_id && expFormik?.errors?.employment_type_id && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.employment_type_id}</span>
                    </div>}
                </div>

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.hr.candidate_detail.cur_emp")}*`}</h6>
                    <SelectSecondaryComponent
                        options={employement}
                        name="employment"
                        placeholder={t("recruitment.profile.placehoder.employment")}
                        isSearchable={false}
                        arrow={true}
                        components={{ DropdownIndicator }}
                        onChange={(e: any) => { expFormik.setFieldValue("employment", e); if (e?.value !== "private") { setCtcErr(false) } else { setGradeErr(false); setBasicPayErr(false); } }}
                        onBlur={(e: any) => expFormik.setFieldTouched("employment", e)}
                        value={!!expFormik.values.employement ? employement?.find((item: any) => item?.value === expFormik.values.employement?.value) : expFormik.values.employement}
                    />
                    {expFormik?.touched?.employment && expFormik?.errors?.employment && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.employment}</span>
                    </div>}
                </div>

                {(!!expFormik.values.employment?.value && expFormik.values.employment?.value !== "private") &&
                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.home.job_list.pay_scale")}*`}</h6>
                        <div className={`rounded-[6px] border border-[#D7D8DD] dark:border-[#454545] h-[35px] xlx:h-[40px] w-full relative flex items-center ${scaleFcs ? "bg-white dark:bg-bgDarkDull" : "hover:bg-white bg-[#F5F5F5] dark:bg-bgDark  dark:hover:bg-bgDarkDull"}`}>
                            <input className="placeholder:text-blackDull rounded-[6px] bg-transparent w-full text-blackDull text-sm leading-snug h-full pl-[15px] xlx:pl-[17px] pr-[40px] dark:text-textBlackDull placeholder:dark:text-textBlackDull" type="text" name="pay_scale_gov" placeholder={t("recruitment.home.job_list.pay_scale")} value={expFormik?.values?.pay_scale_gov} onBlur={expFormik?.handleBlur} onChange={(e: any) => { expFormik?.handleChange(e); !!e.target.value ? setGradeErr(false) : setGradeErr(true) }} onFocus={() => setScaleFcs(true)} onKeyDown={handleKeyDown} />

                            <div className="absolute right-[10px] cursor-pointer h-full flex items-center justify-center">
                                <div className="group relative h-full flex items-center justify-center" ref={ref}>
                                    <button type="button" className="focus:shadow-[0_0_0_2px_#4145525e] hover:shadow-[0_0_0_2px_#4145525e] rounded-full flex items-center justify-center xlx:w-[14px] xlx:h-[14px] h-[13px] w-[13px]" onClick={() => setOpen(true)} onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
                                        <Info />
                                    </button>
                                    {open && <span className="absolute top-[35px] right-[-90px] bg-white dark:bg-bgDarkDull border border-[rgba(19,63,151,0.1] dark:border-[#454545] rounded-[10px] py-[6px] px-[14px] z-[1] divide-blackbg-white before:absolute before:content-[''] before:top-[0px] before:right-[35%] before:w-[10px] before:h-[10px] before:bg-white before:dark:bg-bgDarkDull before:-translate-y-1/2 before:-translate-x-1/2 before:rotate-45 transition-all text-xs text-blackDark font-semibold scale-100 hidden group-hover:block w-[250px] shadow-[0px_2px_7px_0px_rgba(0,0,0,0.12)]">
                                        {t("recruitment.profile.field.pay_scale_desc")}
                                    </span>}
                                </div>
                            </div>
                        </div>

                        {!!gradeErr && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.pay_scale")}</span>
                        </div>}
                    </div>}


                {(!!expFormik.values.employment?.value && expFormik.values.employment?.value !== "private") && <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.hr.candidate_detail.basic_pay")}*`} type="number" name="basic_pay" placeholder={t("recruitment.hr.candidate_detail.basic_pay")} exceptThisSymbols={["e", "E", "+", "-", "."]} value={expFormik?.values?.basic_pay} onBlur={expFormik?.handleBlur} onChange={(e: any) => { expFormik?.handleChange(e); !!e.target.value ? setBasicPayErr(false) : setBasicPayErr(true) }} />
                    {!!basicPayErr && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.basic_pay")}</span>
                    </div>}
                </div>
                }

                {(!!expFormik.values.employment?.value && expFormik.values.employment?.value === "private") && <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.ctc")}*`} type="number" name="pay_scale" placeholder={t("recruitment.profile.field.ctc")} exceptThisSymbols={["e", "E", "+", "-", "."]} value={expFormik?.values?.pay_scale} onBlur={expFormik?.handleBlur} onChange={(e: any) => { expFormik?.handleChange(e); !!e.target.value ? setCtcErr(false) : setCtcErr(true) }} />
                    {!!ctcErr && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{t("recruitment.profile.err.ctc")}</span>
                    </div>}
                </div>
                }

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("recruitment.profile.field.experience_type")}*`}</h6>
                    <SelectSecondaryComponent
                        options={exeType}
                        name="experience_type"
                        placeholder={t("recruitment.profile.placehoder.experience_type")}
                        isSearchable={false}
                        arrow={true}
                        components={{ DropdownIndicator }}
                        onChange={(e: any) => { expFormik.setFieldValue("experience_type", e); }}
                        onBlur={(e: any) => expFormik.setFieldTouched("experience_type", e)}
                        value={!!expFormik.values.experience_type ? exeType?.find((item: any) => item?.value === expFormik.values.experience_type?.value) : expFormik.values.experience_type}
                    />
                    {expFormik?.touched?.experience_type && expFormik?.errors?.experience_type && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.experience_type}</span>
                    </div>}
                </div>


                <div className="flex flex-col gap-[4px]">
                    <PrimaryInput title={`${t("recruitment.profile.field.location")}*`} name="location" type="text" placeholder={t("recruitment.profile.field.location")} value={expFormik?.values?.location} onBlur={expFormik?.handleBlur} onChange={expFormik?.handleChange} />
                    {expFormik?.touched?.location && expFormik?.errors?.location && <div className="flex gap-[6px] items-start"><Warn />
                        <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.location}</span>
                    </div>}
                </div>

            </div>

            <div className="flex flex-col gap-[4px]">
                <PrimaryTextarea title={`${t("recruitment.profile.field.nature_work")}*`} placeholder={t("recruitment.profile.placehoder.start_tying")} rows="4" name="nature_of_work" value={expFormik?.values?.nature_of_work} onChange={expFormik?.handleChange} onBlur={expFormik?.handleBlur} />
                {expFormik?.touched?.nature_of_work && expFormik?.errors?.nature_of_work && <div className="flex gap-[6px] items-start"><Warn />
                    <span className="text-danger dark:text-darkDanger text-xs font-medium">{expFormik?.errors?.nature_of_work}</span>
                </div>}
            </div>

            <div className="flex flex-col gap-[4px]">
                <PrimaryTextarea title={`${t("recruitment.profile.field.gap_reason")}*`} placeholder={t("recruitment.profile.placehoder.start_tying")} rows="4" name="gap_reason" value={expFormik?.values?.gap_reason} onChange={expFormik?.handleChange} />
            </div>

            <div className="flex items-end justify-end w-full">
                <SecondaryBtn title={t("recruitment.hr.create_ad.field.save")} css="px-[24px] font-semibold rounded-[6px] text-sm leading-snug !h-[35px]" onClick={expFormik?.handleSubmit} />
            </div>
        </div>
    );
};

export default Experiences;